export const PAGE_VIEWED = 'Page Visited';
export const TIMESLOT_SELECTED = 'Timeslot Selected';
export const RESTAURANT_VIEWED = 'Restaurant Viewed';
export const INITIATE_SIGNUP = 'Initiated Signed Up';
export const VIEWED_RESTAURANT_PACKAGE = 'Viewed Restaurant Package';
export const SEARCH = 'Search';
export const INITIATED_TO_BOOK = 'Initiated To Book';
export const CHARGED = 'Charged';
export const PROMOTION_TAPPED = 'Promotion Tapped';
export const BLOGGER_REVIEW_TAPPED = 'Blogger review tapped';
export const BLOGGER_TAPPED = 'Blogger tapped';
export const MORE_BLOGGER_REVIEW_TAPPED = 'More blogger review tapped';
export const MORE_REVIEW_TAPPED = 'More review tapped';
export const RESTAURANT_SECTION_TAPPED = 'Restaurant Section Tapped';
export const RESTAURANT_FULLY_BOOKED = 'Restaurant Fully Booked';
export const USER_SIGNED_UP = 'User Signed Up';
export const USER_SIGNED_IN = 'User Signed In';
export const RESTAURANT_YOUTUBE_PLAYED = 'Restaurant Youtube Played';
export const BOOKING_STEP_ADULT_SELECTED = 'Booking step adult selected';
export const BOOKING_STEP_ADD_KIDS = 'Booking Step Add Kids';
export const BOOKING_STEP_DATE_SELECTED = 'Booking Step Date Selected';
export const BOOKING_STEP_TIME_SELECTED = 'Booking Step Time Selected';
export const BOOKING_STEP_BIG_GROUP = 'Booking Step Big Group';
export const BOOKING_STEP_BIG_GROUP_SUBMIT = 'Booking Step Big Group Submit';
export const BOOKING_STEP_BIG_GROUP_CONFIRMED = 'Booking Step Big Group Confirmed';
export const BOOKING_STEP_PACKAGE_SELECTED = 'Booking Step Package Selected';
export const BOOKING_STEP_PACKAGE_QUANTITY = 'Booking Step Package Quantity';
export const BOOK_NOW_BUTTON = 'Book Now Button';
